"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = (e) => {
    const products = e.data;
    window.digitalData.product = [];
    if (products.length || Object.keys(products).length) {
        window.digitalData.product.push({
            productInfo: {
                productID: products.identifierValue || 'NA',
                productName: products.productName || 'NA',
                brand: products.brandName || 'NA',
                sku: products.identifierValue || 'NA',
            },
            category: {
                primaryCategory: products.category || 'NA',
            },
            attributes: {
                productPosition: products.position || 'NA',
                productVariants: products.size,
                listPosition: null,
                pcatName: products.catName || 'NA',
                pcatValue: products.catValue || 'NA',
                prodRetailer: products.retailer || 'NA',
                productBrand: products.brandName || 'NA',
                productAward: products.award || 'NA',
                productFindingMethod: '',
            },
        });
    }
    if (typeof window.ctConstants === 'undefined')
        return;
    const analyticsEvent = {};
    analyticsEvent.eventInfo = {
        type: window.ctConstants.trackEvent,
        eventAction: window.ctConstants.purchase,
        eventLabel: `Online - ${products.productName}`,
        eventValue: 1,
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.conversion,
    };
    analyticsEvent.attributes = { nonInteractive: { nonInteraction: 1 } };
    analyticsEvent.subcategory = 'Lead';
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
